export default __webpack_public_path__ + "static/media/sponsor-icon-active.a2f60f25.webp";